import "./App.css";
import Weather from "./component/Weather";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
const API_key = "0612d007720e7a72a7ed4e4ee3631462";

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      count: 0,
      api_country: "",
      country: "",
      city: "",
      icon: "",
      icon_id: "",
      main: "",
      celsius: "",
      temp_min: "",
      temp_max: "",
      description: "",
      id: "",
      iconUrl: "",
      error: true,
    };
  }

  calCel(temp) {
    let cdeg = Math.floor(temp - 273.15);
    return cdeg;
  }
  getCountry = async (e) => {
    e.preventDefault();

    const city_value = e.target.city.value;
    console.log(city_value);

    if (city_value) {
      const api_call = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city_value}&appid=${API_key}`
      );
      const response = await api_call.json();
      // console.log(response);
      this.setState({
        city: `${response.name}, ${response.sys.country}`,
        celsius: this.calCel(response.main.temp),
        temp_min: this.calCel(response.main.temp_min),
        temp_max: this.calCel(response.main.temp_max),
        description: response.weather[0].description,
        icon_id: response.weather[0].icon,
        id: response.weather[0].id,
        main: response.weather[0].main,
        error: false,
      });
      console.log("Weather", response);
    } else {
      return <h1>Rechech</h1>;
    }
  };

  render() {
    const {
      count,
      id,
      city,
      country,
      icon,
      icon_id,
      main,
      celsius,
      temp_max,
      temp_min,
      description,
      error,
    } = this.state;
    if ({ count } === 0) {
      return <div>running</div>;
    }
    return (
      <div className="App">
        <form onSubmit={this.getCountry}>
          <input
            className="input"
            type="text"
            name="city"
            placeholder="Enter Your City"
            autoComplete="off"
          />
        </form>
        <Weather
          id={id}
          main={main}
          city={city}
          country={country}
          icon={icon}
          icon_id={icon_id}
          celsius={celsius}
          temp_min={temp_min}
          temp_max={temp_max}
          description={description}
          error={error}
        />
        {/* <Delay wait={6000}></Delay> */}
      </div>
    );
  }
  // componentDidMount() {
  //   this.myCount = setInterval(() => {
  //     this.setState((prevState) => ({
  //       count: prevState.count + 1,
  //     }));
  //   }, 1000);
  // }
}

export default App;

// <Weather
//           id={id}
//           main={main}
//           city={city}
//           country={country}
//           icon={icon}
//           icon_id={icon_id}
//           celsius={celsius}
//           temp_min={temp_min}
//           temp_max={temp_max}
//           description={description}
//         />
